<template>
  <div :id="($attrs.key || '')+'_image_container'" class="w-full" @click="$emit('imageClick')">
    <div class="img_container" :class="[image_classes, image_dimension_class, {'image_circular': imageCircular}]" :style=" image_src ? 'background-image: url('+image_src+')' : ''" />
    <img v-if="av_image_src" :src="av_image_src" class="hidden" :alt="altAttribute" @error="generateBase64" />
  </div>
</template>
<style type="text/css" scoped>
  .img_container {
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-color: var(--background-layer-02);
  }

  .img_container.dimension_1x1 {
    padding-bottom: 100%;
  }

  .img_container.dimension_4x3 {
    padding-bottom: 75%;
  }

  .img_container.dimension_3x1 {
    padding-bottom: 34%;
  }

  .img_container.dimension_4x5 {
    padding-bottom: 125%;
  }

  .img_container.image_circular {
    border-radius: 50%;
  }
</style>
<script>
  export default {
    props: {
      imageSrc: {
        type: String,
        required: true
      },
      imageClasses: {
        type: Array,
        required: false,
        default() {
          return [];
        }
      },
      imageDimension: {
        type: String,
        default: '1x1',
        required: false,
        validator(value) {
          return Boolean(['1x1','4x3','3x1','4x5'].indexOf(value)>=0);
        }
      },
      defaultImage: {
        type: String,
        default: '',
        required: false
      },
      imageCircular: {
        type: Boolean,
        required: false,
        default: false
      },
      altAttribute: {
        type: String,
        required: false,
        default: ''
      }
    },
    data() {
      return {
        primary_image_fail: false,
        converted_image: null
      }
    },
    computed: {
      av_image() {
        return this.$FUSparseAVImageString(this.imageSrc);
      },
      av_image_src() {
        return this.av_image && this.av_image.image?this.av_image.image:null;
      },
      image_src() {
        return this.converted_image || (this.primary_image_fail?this.defaultImage:this.av_image_src);
      },
      image_classes() {
        return this.imageClasses.length>0?this.imageClasses.join(' '):'';
      },
      image_dimension_class() {
        return 'dimension_'+this.imageDimension;
      }
    },
    methods: {
      generateBase64(imageTag) {
       this.$emit('errorLoading');
        //TODO: replace heic2any library. disabled since it's 'breaking' images in mobile
        this.primary_image_fail = true;
        // var self = this;
        // var img = imageTag.currentTarget;
        // if (img) {
        //     var imgURL = new URL(img.src);
        //     var imgURI = imgURL.pathname;
        //
        //     if (imgURI) {
        //         fetch(`/app${imgURI}`)
        //             .then((res) => res.blob())
        //             .then((blob) => heic2any({blob}))
        //             .then((conversionResult) => {
        //                 self.converted_image = URL.createObjectURL(conversionResult);
        //                 // conversionResult is a BLOB
        //                 // of the PNG formatted image
        //             })
        //             .catch((e) => {
        //                 // see error handling section
        //             });
        //     }
        // }
      }
    }
  }
</script>
